export const TEXTS = [
{
    title: "Estude Nas Melhores Faculdades Da Argentina!",
    desc: "Realize seu sonho de cursar Medicina, Engenharia, Arquitetura, Odontologia, Medicina Veterinária, entre outros cursos, sem precisar prestar vestibular, em faculdades públicas de excelente qualidade!",
    link: "https://wa.me/21993967172" 
},
{
    title: "Quem Somos Nós?",
    desc: "Nós, da Alfa Assessoria Estudantil, cuidamos de toda a questão burocrática em relação a documentação, trâmites da faculdade, matrícula, trâmites de identidade argentina, residência, orientação , entre outros. Somos compostos também por estudantes e diferentemente de muitas assessorias que visam o lucro com altas taxas e assuntos rasos, buscamos a excelência de atendimento por um preço menor e justo, facilitando a todos a oportunidade de realizar o sonho de cursar medicina! E não só Medicina mas também Odontologia, Engenharia, Arquitetura, Medicina Veterinária e muitas outras opções!",
    subtitle: "Comece hoje mesmo uma nova etapa para sua vida!" 
}
]

export const PLANS = [
{
    title: "PACOTE SIMPLES",
    options: [
        {opt:"Suporte on-line para o assessorado", key:1},
        {opt:"Pré inscrição universitária",key:2 },
        {opt:"Legalização de documentos necessários", key:3},
        {opt:"Auxilio de trâmites de DNI", key:4},
        {opt:"Pagamentos de taxas dos orgãos do Governo Argentino", key:5},
    ],
    price:"R$ 2800,00",
    link: "https://wa.me/5521993967172" 
},
{
    title: "PACOTE PREMIUM",
    options:[
        {opt:"Auxílio nos trâmites residenciais na Argentina", key: 6},
        {opt:" Recepção no aeroporto", key: 7},
        {opt:" Orientação acadêmicas", key: 8},
        {opt:" Chip e cartão de transporte público.", key: 9},
        {opt:" Além dos citados no pacote simples", key: 10},
    ],
    price:"R$ 3500,00",
    link: "https://wa.me/5521993967172" 
}
]


